module.exports = __webpack_public_path__ + "static/brand-top-7fdaf94d7a2419e35dd6e27eb484fcd0.webp";